import React from 'react';
import Page from './Page';
import Tooltips from './Tooltips';
import { TextField } from 'material-ui';
import ShortForm from './ShortForm';

export default class SendMessage extends Page {

	render(){

		let form = this.app.sendMessageForm;

		return (
			<ShortForm 
				label={<span>Contact A Participant <Tooltips id='contactParticipant' /></span>}
				formWidth="small"
				submitButton={{label:"Send", onClick:() => { form.submit()}}}
				waiting={form.loading}
				errorMessage={form.errorMessage}
			>

				<TextField
					label="Participant Message Token"
					value={form.messageToken || ''}
					onChange={ e =>{ form.messageToken = e.currentTarget.value; this.app.forceUpdate(); } }
					margin="normal"
					fullWidth
					/>

				<TextField
					label="Subject"
					value={form.messageSubject || ''}
					onChange={ e =>{ form.messageSubject = e.currentTarget.value; this.app.forceUpdate(); } }
					margin="normal"
					fullWidth
					/>

				<TextField
					label="Message"
					value={form.messageBody || ''}
					onChange={ e =>{ form.messageBody = e.currentTarget.value; this.app.forceUpdate(); } }
					margin="normal"
					multiline
					rowsMax="20"
					fullWidth
					/>


			</ShortForm>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/SendMessage.js